import React from 'react';

interface SparkleIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

const SparkleIcon: React.FC<SparkleIconProps> = ({ 
  width = 16, 
  height = 16, 
  fill = '#000000' 
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.60866 2.29242C7.65262 2.17887 7.81449 2.17649 7.86168 2.28873C9.16641 5.39173 10.5063 6.75689 13.7217 8.13312C13.8307 8.17977 13.8312 8.33597 13.7225 8.38311C10.633 9.7219 9.27912 11.0695 7.86187 14.2452C7.8132 14.3543 7.65555 14.3513 7.61113 14.2404C6.37284 11.1501 5.02785 9.79224 1.74983 8.38667C1.63938 8.33931 1.6411 8.18021 1.75255 8.13528C5.00103 6.82585 6.38047 5.46467 7.60866 2.29242Z"
        fill={fill}
        fillOpacity="0.88"
      />
      <path
        d="M12.4058 1.75999C12.4542 1.64823 12.6186 1.64585 12.6698 1.75635C13.0329 2.54077 13.4368 2.94595 14.2543 3.32615C14.3618 3.37614 14.3622 3.53376 14.255 3.58437C13.4658 3.95691 13.0601 4.36163 12.6688 5.17195C12.6168 5.27947 12.4575 5.27617 12.4091 5.16699C12.061 4.38107 11.6565 3.97575 10.8231 3.58782C10.7141 3.53711 10.7159 3.3764 10.8258 3.32782C11.6486 2.96414 12.06 2.55965 12.4058 1.75999Z"
        fill={fill}
        fillOpacity="0.88"
      />
    </svg>
  );
};

export default SparkleIcon;
